export default "__VITE_ASSET__B$ezcNFo__"